import { fg } from '@atlaskit/platform-feature-flags';

import {
	DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
	DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
} from '../../entities';
import {
	NounSubtypeKey,
	TypeFilterValueKey,
	type TypeFilterValue3PEntities,
} from '../../filters/universal-type';
import { get3PLogo } from '../../icons';
import { type ThirdPartyConfig } from '../../schemas/3p-config';

import { ServiceNowIcon } from './icon';
import { ServiceNowSearchResultIcon } from './search-result-icon';

const getServiceNowTypeFilterConfig = () => {
	const config = new Map<TypeFilterValueKey, TypeFilterValue3PEntities>();

	config.set(TypeFilterValueKey.WorkItem, {
		entities3P: DEFAULT_CLOUD_GRAPH_WORK_ITEM_ENTITY_ATI,
		subTypes3P: [],
	});

	if (fg('rovo_search_document_filter_enable_for_servicenow')) {
		config.set(TypeFilterValueKey.Document, {
			entities3P: DEFAULT_CLOUD_GRAPH_DOCUMENT_ENTITY_ATI,
			subTypes3P: [NounSubtypeKey.Document, NounSubtypeKey.Article],
		});
	}

	if (fg('enable_rovo_search_comment_filter_for_servicenow')) {
		config.set(TypeFilterValueKey.Comment, {
			entities3P: DEFAULT_CLOUD_GRAPH_COMMENT_ENTITY_ATI,
			subTypes3P: [],
		});
	}

	return config;
};

export const serviceNowConfig: ThirdPartyConfig = {
	displayName: 'ServiceNow',
	id: 'servicenow',
	icon: get3PLogo(ServiceNowIcon, 'ServiceNow', 'medium'),
	resourceType: 'servicenow-connector',
	searchResultIcon: get3PLogo(ServiceNowSearchResultIcon, 'ServiceNow', 'large'),
	integrationAri: 'ari:cloud:platform::integration/servicenow', // this hasn't been implemented in the codebase yet, so will need to confirm that it is correct in the future,
	get typeFilterConfig() {
		return getServiceNowTypeFilterConfig();
	},
	filters: ['lastUpdated', 'onlyTitleMatch'],
	requiresOauth: true,
	isEnabled: () => true,
};
